<div *ngIf="selectedTab$ | async as selectedTab" class="tabs-wrap">
	@for(tab of tabInfo; track tab.id) {
		<div *ngIf="tab.visible !== false" (click)="onTabClicked(tab)" [class]="getTabClass(tab, selectedTab)">
			<i [class]="tab.icon"></i>{{tab.text}}<span class="counter-badge" *ngIf="tab.counter !== undefined"
			[style.backgroundColor]="tab.counter === tab.counterTotal ? '#aae293' : 'rgb(217, 237, 247)'">{{displayCounter(tab)}}</span>
		</div>
	}
</div>
